import React from "react";
import { cn } from "../../lib/utils";

interface MobileIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  badge?: number;
  variant?: "filled" | "plain";
}

const MobileIconButton = React.forwardRef<HTMLButtonElement, MobileIconButtonProps>(
  ({ label, badge, variant = "filled", className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      className={cn(
        "relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-0 p-0 text-gray-700 transition-transform active:scale-95 disabled:opacity-40 [-webkit-tap-highlight-color:transparent]",
        variant === "filled" ? "bg-white shadow-[0_1px_3px_rgba(13,14,19,0.08)] ring-1 ring-gray-100" : "bg-transparent",
        className,
      )}
      {...props}
    >
      {children}
      {!!badge && badge > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-primary-600 px-1 text-[10px] font-bold text-white ring-2 ring-gray-50">
          {badge}
        </span>
      )}
    </button>
  ),
);
MobileIconButton.displayName = "MobileIconButton";

export default MobileIconButton;
